<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="project"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column label="工程名称" width="150">
        <template slot-scope="scope" style="max-height: 100%">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.ProjectName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="ClientName"
        label="客户名称"
        sortable
      ></el-table-column>
      <el-table-column
        prop="ProjectAddress"
        label="工程地址"
        sortable
      ></el-table-column>
      <el-table-column prop="Distance" label="运距" sortable></el-table-column>
      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        sortable
      ></el-table-column>
      <el-table-column
        prop="CreateUser"
        label="创建者"
        sortable
      ></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status == 0 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="客户名称" prop="ClientName">
          <el-input
            v-model="editForm.ClientName"
            class="input-clientname"
            readonly
          />
          <el-button
            type="primary"
            @click="visibleDialog = true"
            :loading="editLoading"
          >
            选择
          </el-button>
        </el-form-item>
        <el-form-item label="工程名称" prop="ProjectName">
          <el-input
            v-model="editForm.ProjectName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="工程地址" prop="ProjectAddress">
          <el-input
            v-model="editForm.ProjectAddress"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="工程运距" prop="Distance">
          <el-input
            v-model="editForm.Distance"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="editForm.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="更新所有单据">
          <el-checkbox v-model="checkedtz">更新</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="客户名称" prop="ClientName">
          <el-input
            v-model="addForm.ClientName"
            class="input-clientname"
          />
          <el-button
            type="primary"
            @click="visibleDialog = true"
            :loading="editLoading"
          >
            选择
          </el-button>
        </el-form-item>
        <el-form-item label="工程名称" prop="ProjectName">
          <el-input
            v-model="addForm.ProjectName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="工程地址" prop="ProjectAddress">
          <el-input
            v-model="addForm.ProjectAddress"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="工程运距" prop="Distance">
          <el-input
            v-model="addForm.Distance"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="addForm.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered" style="">
        <tr>
          <th>客户名称</th>
          <td>{{ DetailDm.ClientName }}</td>
          <th>工程名称</th>
          <td>{{ DetailDm.ProjectName }}</td>
        </tr>
        <tr>
          <th>工程地址</th>
          <td>{{ DetailDm.ProjectAddress }}</td>
          <th>工程运距</th>
          <td>{{ DetailDm.Distance }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ DetailDm.ProjectAddress }}</td>
        </tr>
      </table>
    </el-dialog>
    <TableDataDialog
      title="客户选择"
      :visibleDialog="visibleDialog"
      :queryMethod="queryData"
      :columns="{
        ClientName: {
          label: '客户名称',
        },
        Remark: {
          label: '备注',
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="setVisible"
      @callback="dialogCallback"
    ></TableDataDialog>
  </section>
</template>

<script>
import * as api from "../../api/project";
import { getClientListPage } from "../../api/client";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      project: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        ProjectName: [
          { required: true, message: "请输入工程名称", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        ProjectName: "",
        Remark: "",
        Status: 0,
        ClientName: "",
        ClientID: "",
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        ProjectName: [
          { required: true, message: "请输入工程名称", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        ProjectName: "",
        Remark: "",
        ClientName: "",
        ClientID: "",
      },
      visibleDialog: false,
      isShowDetail: false,
      DetailDm: {},
      checkedtz: false,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getProject();
    },
    //获取客户列表
    getProject() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getProjectListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.project = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteProject(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getProject();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.checkedtz = false;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateUser: "",
      };
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editForm.IsUpdate = this.checkedtz ? 1 : 0;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .editProject(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getProject();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.editLoading = false;
            });
        }
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addProject(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getProject();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailDm = row;
      this.isShowDetail = !this.isShowDetail;
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getProject();
    },
    dialogCallback(data) {
      if (data.length > 0) {
        this.addForm.ClientName = data[0].ClientName;
        this.addForm.ClientID = data[0].Id;
        this.editForm.ClientName = data[0].ClientName;
        this.editForm.ClientID = data[0].Id;
      }
      this.visibleDialog = false;
    },
    queryData(params) {
      return getClientListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
  },
  mounted() {
    this.getProject();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped>
.input-clientname {
  width: 300px;
}
</style>
